module.exports = __webpack_public_path__ + "assets/img/btn-back-56672650.png";